module.exports = __webpack_public_path__ + "img/pumpkin.87f84618.png";